import { IonButton, IonSpinner } from "@ionic/react";
import { useSelector } from "react-redux";
import { selectUpdateStatus } from "../../../store/userAuthentication/selectors/selectUpdateStatus";

export const FormButtonSubmit: React.FC<{ loading?: boolean }> = ({ loading }) => {
  const updateStatus = useSelector(selectUpdateStatus);
  const pending = loading ?? updateStatus === "pending";
  return (
    <IonButton
      type="submit"
      expand="block"
      style={{ marginTop: 40 }}
      disabled={pending}
    >
      {pending ? <IonSpinner /> : "Actualizar"}
    </IonButton>
  );
};
